import { LIVE_PRODUCT_SUBSCRIPTION_STATUSES } from "utils";

import { type StatusBadgeTone } from "src/components/StatusBadge";
import { type ProductSubscriptionStatus } from "src/queries/productSubscriptions";

export type ProductSubscriptionDisplayStatus =
  | ProductSubscriptionStatus
  | "CANCEL_SCHEDULED";

export const PRODUCT_SUBSCRIPTION_STATUS_TONES: Record<
  ProductSubscriptionDisplayStatus,
  StatusBadgeTone
> = {
  TRIALING: "sky",
  ACTIVE: "green",
  CANCEL_SCHEDULED: "amber",
  PAST_DUE: "red",
  CANCELED: "slate",
  UNPAID: "red",
  INCOMPLETE_EXPIRED: "slate",
};

export function getProductSubscriptionDisplayStatus(subscription: {
  status: ProductSubscriptionStatus;
  cancelAt: string | null;
}): ProductSubscriptionDisplayStatus {
  return subscription.cancelAt !== null &&
    LIVE_PRODUCT_SUBSCRIPTION_STATUSES.includes(subscription.status)
    ? "CANCEL_SCHEDULED"
    : subscription.status;
}
